<template>
  <div class="credittransfer-list">
    <Toolbar :handle-add="addHandler" />

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1>{{ $t('CreditTransfer List') }}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <CreditTransferFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :loading="isLoading"
            :loading-text="$t('Loading...')"
            :no-results-text="$t('No data available')"
            :no-data-text="$t('No data available')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            hide-default-header
            @update:options="onUpdateOptions"
            :footer-props="{ 'items-per-page-text': $t('Records per page') }"
          >

            <template slot="header" slot-scope="{ props: { headers } }">
              <thead>
              <tr>
                <th v-for="header in headers" :key="header.text">
                  {{ $t(header.text)}}
                </th>
              </tr>
              </thead>
            </template>

            <template v-slot:item.amount="{ item }">
              {{ $n(item['amount']['amount'] / 100, 'currency') }} {{ item['amount']['currency'] }}
            </template>

            <template v-slot:item.creditor="{ item }">
              <router-link :to="{ name: 'PartyShow', params: { id: item['creditor'] }}">
                {{ item['creditor'] }}
              </router-link>
            </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
              :handle-edit="() => editHandler(props.item)"
              :handle-delete="() => deleteHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import CreditTransferFilterForm from '../../components/credittransfer/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'CreditTransferList',
  servicePrefix: 'CreditTransfer',
  mixins: [ListMixin],
  components: {
    Toolbar,
    ActionCell,
    CreditTransferFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: 'amount', value: 'amount' },
        { text: 'creditor', value: 'creditor' },
        { text: 'remittanceInfo', value: 'remittanceInfo' },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('credittransfer', {
      items: 'list'
    }),
    ...mapFields('credittransfer', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('credittransfer', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
